import { gql } from 'graphql-tag';
import { templateMappingDetail } from '../mapping/mutations';

const communityUserFragment = gql`
  fragment communityUserDetail on CommunitiesUser {
    id
    admin
    user {
      name
      id
    }
  }
`;

export const getUserRoleQuery = gql`
  query getUserRole($id: ID!) {
    communities_user(id: $id) {
      id
      admin
      user {
        id
      }
    }
  }
`;

export const getCommunityUsersQuery = gql`
  query getCommunityUsers($communityId: ID!) {
    community(id: $communityId) {
      id
      communities_users {
        ...communityUserDetail
      }
    }
  }
  ${communityUserFragment}
`;

export const getFavoriteIdsQuery = gql`
  query getFavorites {
    template_favourites {
      id
    }
  }
`;

export const getFavoriteLayoutsQuery = gql`
  query getFavorites($page: Int, $perPages: Int!) {
    template_favourites(page: $page, per_page: $perPages) {
      id
      categories {
        id
      }
      title
      preview_image_url
      data
      layout_type
      template_element_mappings {
        ...templateMappingDetail
      }
    }
  }
  ${templateMappingDetail}
`;

export const getCommunityIdFromBookIdQuery = gql`
  query getCommunityIdFromBookId($bookId: ID!) {
    book(id: $bookId) {
      id
      community_id
    }
  }
`;
